import React from "react";
import PropTypes from "prop-types";
import DismissButton from "../../Buttons/DismissButton/DismissButton";
import SuccessButton from "../../Buttons/SuccessButton/SuccessButton";

const SaveModal = ({
  children,
  onDismiss,
  onSave,
  showBack,
  isNexButtonFocused,
  ...props
}) => (
  <div className="nextStepModal__outlet">
    <div className="nextStepModal__container">
      {children}
      <div className="nextStepModal__buttons">
        <DismissButton onClick={onDismiss}>
          {showBack ? "BACK" : "DISCARD"}
        </DismissButton>
        <SuccessButton
          onClick={onSave}
          autoFocus={isNexButtonFocused}
          isNexButtonFocused
        >
          SAVE
        </SuccessButton>
      </div>
    </div>
  </div>
);

SaveModal.propTypes = {
  isNexButtonFocused: PropTypes.bool,
  /** Dismiss button function */
  onDismiss: PropTypes.func,
  /** Save button function */
  onSave: PropTypes.func
};
SaveModal.defaultProps = {
  isNexButtonFocused: true
};

export default SaveModal;
